import { render, staticRenderFns } from "./HowToUse.vue?vue&type=template&id=9a0950ae&scoped=true&"
import script from "./HowToUse.vue?vue&type=script&lang=ts&"
export * from "./HowToUse.vue?vue&type=script&lang=ts&"
import style0 from "./HowToUse.vue?vue&type=style&index=0&id=9a0950ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0950ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VApp,VBtn,VContainer,VImg,VRow,VWindow,VWindowItem})
